import {useTransition} from '@logistics-frontend/blocks'
import {type ServerError} from '@logistics-frontend/core/utils/network'
import {getUUID} from '@logistics-frontend/utils'
import {useState} from 'react'
import {useParams} from 'react-router-dom'

import {type ActionOpenRover, fetchOpenRoverAndEventPolling, fetchSharedRouteInfo} from 'src/api'

import {useSharedRoute} from '../../hooks'
import {RouterParams} from '../../types'

export function useOpenRover(action: ActionOpenRover) {
  const key = useParams<RouterParams>().sharingKey
  const [revisionEvent, setRevisionEvent] = useState<number>(0)

  const [, startRouteTransition] = useSharedRoute()
  const [{isPending}, startTransition] = useTransition<void, ServerError>(undefined, {
    key: 'shared-route/rover-action',
  })

  function openRoverHandler(onSendOpenCommand?: VoidFunction) {
    const requestId = getUUID()

    startTransition(
      () =>
        fetchOpenRoverAndEventPolling(
          {
            key,
            request_id: requestId,
            action: action.action,
            payload: action.payload,
          },
          revisionEvent,
          onSendOpenCommand,
        ).then(response => {
          setRevisionEvent(response.revision)
          if (response.message) {
            throw new Error(response.message.dialog?.title ?? 'Не получилось открыть крышку')
          }
        }),
      {
        onCommit() {
          startRouteTransition(() => fetchSharedRouteInfo({key}))
        },
      },
    )
  }

  return {
    isPending,
    openRoverHandler,
  } as const
}
